import type { BookingDetailsState } from '../../domain/types'

export function getIsBookingDetailsPageLoadIdle(state: BookingDetailsState): boolean {
  return state.bookingDetailsPageLoadStatus === 'idle'
}

export function getIsBookingDetailsPageLoadPending(state: BookingDetailsState): boolean {
  return state.bookingDetailsPageLoadStatus === 'idle'
    || state.bookingDetailsPageLoadStatus === 'loading'
}

export function getIsBookingDetailsPageLoadError(state: BookingDetailsState): boolean {
  return state.bookingDetailsPageLoadStatus === 'error'
}

export function getIsBookingDetailsNotFound(state: BookingDetailsState): boolean {
  return state.bookingDetailsPageLoadStatus === 'not-found'
}

export function getIsBookingDetailsPageLoadSuccess(state: BookingDetailsState): boolean {
  return state.bookingDetailsPageLoadStatus === 'success'
}
